// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessMessage_wrapper__2W8TN"};